/**
 * 에너지 사용량 포맷팅 유틸리티
 * kWh 단위를 적절한 단위로 변환하여 표시
 */

/**
 * kWh 값을 적절한 단위로 포맷팅
 * - 1,000 kWh = 1 MWh (메가와트시)
 * - 1,000,000 kWh = 1 GWh (기가와트시)
 *
 * @param {number|string} value - kWh 값
 * @param {Object} options - 포맷팅 옵션
 * @param {number} options.decimals - 소수점 자릿수 (기본값: 1)
 * @param {boolean} options.showUnit - 단위 표시 여부 (기본값: true)
 * @returns {string} 포맷팅된 문자열 (예: "1.5 MWh", "500 kWh")
 */
export function formatEnergyUsage(value, options = {}) {
    const num = Number(value);

    // 유효하지 않은 값 처리
    if (isNaN(num) || num === 0) {
        return options.showUnit === false ? "-" : "-";
    }

    const { decimals = 1, showUnit = true } = options;

    // GWh 단위 (1,000,000 kWh 이상)
    if (num >= 1000000) {
        const gwh = num / 1000000;
        return showUnit ? `${gwh.toFixed(decimals)} GWh` : `${gwh.toFixed(decimals)}`;
    }
    // MWh 단위 (1,000 kWh 이상)
    else if (num >= 1000) {
        const mwh = num / 1000;
        return showUnit ? `${mwh.toFixed(decimals)} MWh` : `${mwh.toFixed(decimals)}`;
    }
    // kWh 단위 (1,000 kWh 미만)
    else {
        return showUnit ? `${num.toFixed(decimals)} kWh` : `${num.toFixed(decimals)}`;
    }
}
